import { Task, UpdateGoal, UpdateTask } from '@griply/types';
import { buildTaskRestoreUpdates } from '@griply/utils';
import { useCallback } from 'react';

export type UseRestoreTasksOptions = {
  updateTasks: (updates: UpdateTask[]) => void;
  updateGoal?: (params: { goal: UpdateGoal }) => void;
  onTaskRestored?: (task: Task) => void;
};

export const useRestoreTasks = ({
  updateTasks,
  updateGoal,
  onTaskRestored,
}: UseRestoreTasksOptions) =>
  useCallback(
    (tasks: Task[]) => {
      const { taskUpdates, goalAdjustments, restoredTasks } =
        buildTaskRestoreUpdates({ tasks, updateGoals: !!updateGoal });

      if (!taskUpdates.length) {
        return;
      }

      updateTasks(taskUpdates);
      restoredTasks.forEach((task) => onTaskRestored?.(task));

      if (!updateGoal) {
        return;
      }
      Object.entries(goalAdjustments).forEach(
        ([goalId, { taskCount, completedTaskCount }]) => {
          updateGoal({
            goal: { id: goalId, taskCount, completedTaskCount },
          });
        },
      );
    },
    [updateTasks, updateGoal, onTaskRestored],
  );
